import React, { useState, useEffect, useRef } from 'react';
// import {Link} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer.js';
import CandidateTab2 from './CandidateTab2';
import NotificationPanels from './NotificationPanels';
// import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import '../assets/css/insuff.css'
import '../assets/css/candidate-tab-form.css';
// import UploadIcon from "../assets/img/upload-icon.svg";
// import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import InsuffComponent from './InsuffComponent';
// import { uploadFileViaMultipart } from "../Actions/personalDetailsActions";
import { getInsuffData } from '../Actions/InsuffFlowActions';
import Loader from "./Common/loader";
import StepCount from './Common/StepCountInsuff';
import TickGreenBigIcon from '../assets/img/tick-green-big-icon.svg';
import { useNavigate } from 'react-router-dom';


const InsuffContainer = () => {
  const navigate=useNavigate();
  const InsuffState = useSelector((state) => state?.Insuff);
  const InsuffFileData = useSelector((state) => state?.InsuffFileData);
  const [currentTab, setCurrentTab] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [lastCheck, setLastCheck] = useState(0);
  const [caseSubmitted, setCaseSubmitted] = useState(false);
  const dispatch = useDispatch();


  useEffect(() => {
    const fetchData = async () => {
      dispatch(getInsuffData());
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (InsuffState?.loading) {
      setIsLoading(true);
    } else {
      setIsLoading(false)
    }
    if (InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails) {
      const allCheckSubmitted = Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)
      .every(caseInsuff => caseInsuff[1]?.InsufficiencyRespondedCase?.STATUS == '1');
            if(allCheckSubmitted){
        setCaseSubmitted(true);
        // setTimeout(autoLogout, 8000);
      } else {
        setCaseSubmitted(false);
      }

      const tabArray = Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails).map(caseInsuff => {
        if (caseInsuff[1]?.CaseCheck?.CHECK_NAME) {
          return caseInsuff[1]?.CaseInsuffDetail?.INSUFF_ID
        }
      });
      const pendingChecks = Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)
      .filter(caseInsuff => caseInsuff[1]?.InsufficiencyRespondedCase?.STATUS !== '1');
      if(pendingChecks?.length === 1){
        setLastCheck(1);
      } else {
        setLastCheck(0);
      }
      const firstPendingCase = Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)
      .find(caseInsuff => caseInsuff[1]?.InsufficiencyRespondedCase?.STATUS !== '1');

      if(firstPendingCase && firstPendingCase[1]?.CaseInsuffDetail?.INSUFF_ID){
        setCurrentTab(firstPendingCase[1]?.CaseInsuffDetail?.INSUFF_ID)
      } else if (tabArray?.length) {
        setCurrentTab(tabArray[0])
      }

    } else if(InsuffState?.InsuffData?.status?.toUpperCase() === 'SUCCESS' 
              && !(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails?.length)) { 
                setCaseSubmitted(true);
            // setTimeout(autoLogout, 5000);
    }
  }, [InsuffState])

  useEffect(() => {
    if (InsuffFileData?.loading) {
      setIsLoading(true);
    } else {
      setIsLoading(false)
    }
  }, [InsuffFileData])


  /**
   * 
   * @param {*} e 
   * @func handle tab navigation 
   */
  const onTabClick = (e,name) => {
    // const name = e?.target?.name || e?.target?.name;
    console.log(name,'ggg')
    if (InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails && name) {
      const selectedTab = Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)?.find(insuffData =>
        insuffData[1]?.CaseInsuffDetail?.INSUFF_ID === name);
      if (selectedTab[1]?.CaseInsuffDetail?.INSUFF_ID) {
        setCurrentTab(name);
      }
    }
  }

  const autoLogout = () => {
        localStorage.removeItem("tokenVerification");
        localStorage.removeItem("userVerificationCandidate");
        window.location = "login";
  }

   

  return (
    <>
     
     
       {caseSubmitted&& 
       navigate(`/candidate-form/insuff-thank-you/`)}
     
      <NotificationPanels />
      <Header url={'/candidate-form/insuff'} />
      <Sidebar url={'/candidate-form/insuff'} />
        <section className="main-section candidate-tab-form insuff-tab-form">
          {isLoading && <Loader />}
          <div className="container-fluid">
            <div className="row">
              {
                !!(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails && !(caseSubmitted)) &&
                <>
                  <div className="col-auto bg-gray-mbl">
                    <h5 className="fnt-smi-bld mt-3 candidate-form-heading">Information Required</h5>
                    <CandidateTab2 activeTab={currentTab} onTabClick={onTabClick} />
                  </div>
                </>
              }
              <div className="col bg-gray-mbl">
                {
                   !!(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails && !(caseSubmitted)) && 
                   <StepCount activeTab={currentTab} />
                }
                {/*Form*/}
                {InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails && !(caseSubmitted) ?
                  Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails).map(caseInsuff => {
                    let insuffFileList = InsuffFileData?.InsuffUploadFilesData?.files
                      ?.filter(file => file?.row_num === caseInsuff[1]?.CaseInsuffDetail?.INSUFF_ID)
                    return (
                      (
                        caseInsuff[1]?.CaseInsuffDetail?.INSUFF_ID === currentTab && <InsuffComponent
                          insuffData={caseInsuff[1]}
                          insuffFileList={insuffFileList}
                          allDetails={InsuffState?.InsuffData?.data?.caseInsuffArr?.allDetails}
                          lastCheck={lastCheck}
                        />
                      )
                    )
                  }
                  )
                  :
                !isLoading && <>
                  {/* <div className="row mt-5">
                    <div className="col-md-12 text-center">
                      <img src={TickGreenBigIcon} alt="" width="70" />
                      <h3 className="fnt-smi-bld mb-0 mt-3">Thank you</h3>
                      <p className="text-muted">Your submission has been recieved successfully!</p>

                    </div>
                  </div> */}


                 {/* <div className="row mb-3">
                     <div className="col-sm-6 col-md-12 col-xl-6 no-data-alert">
                      <div class="alert alert-danger">{`No more action required`}</div>
                     </div>
                  </div> */}
                  </>
                }
                {/* {
                  InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails?.length &&
                  InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails.map(insuffData => 
                    (
                      insuffData?.CaseCheck?.CHECK_NAME === currentTab && <InsuffComponent
                      insuffData={insuffData}
                      /> 
                    )
                  )
                } */}
                {/*Form*/}
                {/* <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </section>
        <div style={{
          textAlign: 'center',
          position: 'absolute',
          bottom: !!(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails && !(caseSubmitted)) ? 'auto' : 2,
          margin: 'auto',
          left: 0,
          right: 0,
        }}>
          <Footer />
        </div>
    </>
  );
}
export default InsuffContainer;
